// src/api/file/audioApi.ts
import { ENV } from '../../config/runtimeEnv';
import type { UserUuid } from "../../types/identity";
import { http } from "../../lib/http/client";

const API_BASE_URL = ENV.VITE_FILE_SERVER;

// `report` resolves a ReportFile (audiobooks); `file` a consult recording owned by the patient.
export type AudioSource = "report" | "file";

export interface AudioInfo {
	file_id: string;
	file_name: string;
	file_type: string;
	file_size: number;
	cached: boolean;
}

export const getAudioInfo = async (patientId: UserUuid, fileId: string, source: AudioSource = "report"): Promise<AudioInfo> => {
	const response = await http.post(
		`${API_BASE_URL}/audio-stream/info`,
		{
			patient_id: patientId,
			file_id: fileId,
			source,
		}
	);
	return response.data;
};

export const downloadNormalizedAudio = async (
	patientId: UserUuid,
	fileId: string,
	onProgress?: (progress: number) => void,
	source: AudioSource = "report"
): Promise<Blob> => {
	const response = await http.post(
		`${API_BASE_URL}/audio-stream/download`,
		{
			patient_id: patientId,
			file_id: fileId,
			source,
		},
		{
			responseType: "blob",
			onDownloadProgress: (progressEvent) => {
				if (progressEvent.total && onProgress) {
					const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
					onProgress(percentCompleted);
				}
			},
		}
	);
	return response.data;
};

export const clearAudioCache = async (patientId: UserUuid, fileId: string, source: AudioSource = "report"): Promise<void> => {
	await http.post(
		`${API_BASE_URL}/audio-stream/clear-cache`,
		{
			patient_id: patientId,
			file_id: fileId,
			source,
		}
	);
};